export enum PERMISSION {
  EDIT_PROTOCOL = "Edit Protocol",
}
